const Icon_download = () => (
  <svg
    width={22}
    height={24}
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 5H4C1.79086 5 0 6.79086 0 9V20C0 22.2091 1.79086 24 4 24H18C20.2091 24 22 22.2091 22 20V9C22 6.79086 20.2091 5 18 5H14V7H18C19.1046 7 20 7.89543 20 9V20C20 21.1046 19.1046 22 18 22H4C2.89543 22 2 21.1046 2 20V9C2 7.89543 2.89543 7 4 7H8V5Z"
      fill="white"
      fillOpacity="0.4"
    />
    <path
      d="M7 13L11 17M11 17V1M11 17L15 13"
      stroke="white"
      strokeOpacity="0.85"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Icon_download
